import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function completeJobReducer(state = initialState.completingJob, action) {
  switch (action.type) {
    case types.COMPLETE_JOB_SUCCESS:
      return action.completingJob;

    case types.RELOAD_COMPLETE_JOB_SUCCESS:
      return action.completingJob;

    // Ignore a background refresh that finishes after the engineer has moved to another job
    case types.REFRESH_COMPLETING_JOB:
      return state.orderNumber === action.completingJob.orderNumber ? action.completingJob : state;

    default:
      return state;
  }
}
